// styles/theme.js
export const lightTheme = {
	colors: {
		primary: {
			main: "#FCAEBC", // Soft pink
			light: "#FFD6DD", // Lighter pink
			dark: "#FF9BB7", // Deeper pink
			contrast: "#FFFFFF", // White for contrast
		},
		secondary: {
			main: "#FFB6C1", // Blush pink
			light: "#FFD3E0", // Lighter blush pink
			dark: "#FF8A9A", // Darker blush pink
			contrast: "#FFFFFF", // White for contrast
		},
		background: {
			main: "#FFF5F7", // Light pinkish background
			alt: "#FFE4E9", // Alternate light pink
			paper: "#FFFFFF", // White for cards or paper
		},
		text: {
			primary: "#4A154B", // Deep plum for text
			secondary: "#6D284A", // Softer plum for secondary text
			disabled: "#9B6A89", // Muted plum for disabled text
		},
		error: {
			main: "#E57373", // Soft red for errors
			light: "#FFCDD2", // Light error red
			dark: "#D32F2F", // Darker error red
		},
		success: {
			main: "#81C784", // Soft green for success
			light: "#A5D6A7", // Lighter green
			dark: "#4CAF50", // Deeper green
		},
		warning: {
			main: "#FFB74D", // Soft orange for warnings
			light: "#FFE0B2", // Lighter orange
			dark: "#F57C00", // Darker orange
		},
	},
	spacing: {
		xs: "0.25rem", // 4px
		sm: "0.5rem", // 8px
		md: "1rem", // 16px
		lg: "1.5rem", // 24px
		xl: "2rem", // 32px
		xxl: "2.5rem", // 40px
		"3xl": "3rem", // 48px
		"4xl": "4rem", // 64px
	},
	breakpoints: {
		xs: "320px",
		sm: "576px",
		md: "768px",
		lg: "992px",
		xl: "1200px",
	},
	typography: {
		fonts: {
			body: "'Playfair Display', sans-serif",
			heading: "'Julius Sans One', serif",
		},
		sizes: {
			xs: "0.75rem", // 12px
			sm: "0.875rem", // 14px
			md: "1rem", // 16px
			lg: "1.125rem", // 18px
			xl: "1.25rem", // 20px
			"2xl": "1.5rem", // 24px
			"3xl": "1.875rem", // 30px
			"4xl": "2.25rem", // 36px
			"5xl": "3rem", // 48px
		},
		weights: {
			light: 300,
			regular: 400,
			medium: 500,
			semibold: 600,
			bold: 700,
		},
		lineHeights: {
			tight: 1.25,
			normal: 1.5,
			relaxed: 1.75,
		},
	},
	borderRadius: {
		none: "0",
		sm: "0.125rem",
		md: "0.25rem",
		lg: "0.5rem",
		xl: "0.75rem",
		"2xl": "1rem",
		full: "9999px",
	},
	shadows: {
		none: "none",
		sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
		md: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
		lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
		xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
	},
	transitions: {
		fast: "150ms ease-in-out",
		normal: "250ms ease-in-out",
		slow: "350ms ease-in-out",
	},
	zIndex: {
		navbar: 1000,
		modal: 1300,
		drawer: 1200,
		tooltip: 1500,
	},
};



